// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oenq","left":"styles_left__3fEa2","desktopActions":"styles_desktopActions__DD79p","title":"styles_title__3mnpr"};